module.exports = __webpack_public_path__ + "img/9.2e5ff31b.jpg";